import React from 'react';
import Link from 'next/link';
import { routes } from 'env/routes';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'next/router';
import { inject, observer } from 'mobx-react';
import withCustomComponent from 'ui/components/withCustomComponent';

export const BlogPostCommentsTitle = withCustomComponent(
  'BlogPostCommentsTitle'
)(
  inject(
    'appStore',
    'blogStore'
  )(
    withRouter(
      observer(({ componentName, router, appStore, blogStore }) => {
        const { t } = useTranslation();
        const blogPost = blogStore.blogPostPage.BlogPost;

        return (
          <div
            data-component-name={componentName}
            className="blog-post-comments-title d-flex align-items-center py-12 mb-16 border-bottom text-gray-700 fs-14"
          >
            {blogPost.Comments.length > 0 && (
              <>
                <i className="icon-replies fs-24 mr-4"></i>
                <span>
                  {t('{{count}} comment', {
                    count: blogPost.Comments.length,
                  })}
                </span>
              </>
            )}
            {blogPost.Comments.length == 0 && (
              <>
                {t('Be the first one to leave a comment!')}
              </>
            )}
          </div>
        );
      })
    )
  )
);
